import React from "react";
import ProfilePicture from "./images/megha.png";
import "./App.css";

function App() {
  return (
    <div className="main">
      <img className="pp" src={ProfilePicture} alt="Megha" />
      <Informations />
      <Footer />
    </div>
  );
}

// button and title and about
function Informations() {
  return (
    <div className="informations">
      <Titles />
      <Buttons />
      <About />
    </div>
  );
}
// Footer
function Footer() {
  return (
    <div className="footer">
      <Social />
    </div>
  );
}
function Titles() {
  return (
    <div className="titles">
      <h1 className="title">Megha Dogra</h1>
      <h2 className="job">Fullstack Developer</h2>
      <a href="https://github.com/Megha-prog" className="website">
        megha.com
      </a>
    </div>
  );

}
// email
function Buttons() {
  return (
    <div className="buttons">
      <a href="mailto:meghaadograa@gmail.com" className="btn-email">
        <svg
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.102406 1.70721L6.50001 4.90561L12.8976 1.70721C12.8739 1.29957 12.6953 0.916403 12.3983 0.636194C12.1012 0.355985 11.7083 0.199937 11.3 0.200012H1.70001C1.29167 0.199937 0.898764 0.355985 0.601748 0.636194C0.304733 0.916403 0.126089 1.29957 0.102406 1.70721Z"
            fill="#1E1F26"
          />
          <path
            d="M12.9 3.49441L6.50001 6.69441L0.100006 3.49441V8.20001C0.100006 8.62436 0.268577 9.03133 0.568635 9.33138C0.868693 9.63144 1.27566 9.80001 1.70001 9.80001H11.3C11.7244 9.80001 12.1313 9.63144 12.4314 9.33138C12.7314 9.03133 12.9 8.62436 12.9 8.20001V3.49441Z"
            fill="#1E1F26"
          />
        </svg>
        <p className="btn-text">Email</p>
      </a>
      <a href="https://github.com/" className="btn-github">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          fill="#fff"
          viewBox="0 0 24 24"
        >
          <path
            fill="#fff"
            d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-4.466 19.59c-.405.078-.534-.171-.534-.384v-2.195c0-.747-.262-1.233-.55-1.481 1.782-.198 3.654-.875 3.654-3.947 0-.874-.312-1.588-.823-2.147.082-.202.356-1.016-.079-2.117 0 0-.671-.215-2.198.82-.64-.18-1.324-.267-2.004-.271-.68.003-1.364.091-2.003.269-1.528-1.035-2.2-.82-2.2-.82-.434 1.102-.16 1.915-.077 2.118-.512.56-.824 1.273-.824 2.147 0 3.064 1.867 3.751 3.645 3.954-.229.2-.436.552-.508 1.07-.457.204-1.614.557-2.328-.666 0 0-.423-.768-1.227-.825 0 0-.78-.01-.055.487 0 0 .525.246.889 1.17 0 0 .463 1.428 2.688.944v1.489c0 .211-.129.459-.528.385-3.18-1.057-5.472-4.056-5.472-7.59 0-4.419 3.582-8 8-8s8 3.581 8 8c0 3.533-2.289 6.531-5.466 7.59z"
          />
        </svg>
        <p className="btn-text btn-text-git">Github</p>
      </a>
    </div>
  );
}

function About() {
  return (
    <div className="about">
      <h1 className="atitle">About</h1>
      <p className="stitle">
        I am a Full Stack developer 
      </p>
      <h1 className="atitle">Interests</h1>
      <p className="stitle">
        Javascript Node/Express React Mysql MongoDb CSS HTML SASS
      </p>
    </div>
  );
}

//social -Youtube ,github,hashnode,linkedin
function Social() {
  return (
    <div className="social_icons">
      <a
        href="https://www.linkedin.com/in/megha-dogra-017956b5/"
        className="social_icon"
      >
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="#918E9B"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22.3214 0.5H2.67857C1.19978 0.5 0 1.69978 0 3.17857V22.8214C0 24.3002 1.19978 25.5 2.67857 25.5H22.3214C23.8002 25.5 25 24.3002 25 22.8214V3.17857C25 1.69978 23.8002 0.5 22.3214 0.5ZM19.5926 9.36161C19.6038 9.51786 19.6038 9.67969 19.6038 9.83594C19.6038 14.6741 15.9208 20.2489 9.19085 20.2489C7.11496 20.2489 5.18973 19.6462 3.57143 18.6083C3.86719 18.6417 4.15179 18.6529 4.45313 18.6529C6.1663 18.6529 7.73996 18.0725 8.99554 17.0904C7.38839 17.0569 6.03795 16.0022 5.57478 14.5513C6.13839 14.635 6.64621 14.635 7.22656 14.4844C5.55246 14.144 4.29688 12.6708 4.29688 10.8906V10.846C4.78237 11.1194 5.35156 11.2868 5.94866 11.3092C5.44667 10.9752 5.03515 10.5223 4.75082 9.9906C4.4665 9.45895 4.31821 8.86518 4.3192 8.26228C4.3192 7.58147 4.49777 6.95647 4.81585 6.41518C6.6183 8.63616 9.32478 10.0871 12.3605 10.2433C11.8415 7.76005 13.6998 5.74554 15.9319 5.74554C16.9866 5.74554 17.9353 6.18638 18.6049 6.90067C19.4308 6.74442 20.2232 6.4375 20.9263 6.01897C20.6529 6.86719 20.0781 7.58147 19.3192 8.03348C20.0558 7.95536 20.7701 7.74888 21.4286 7.46429C20.9319 8.19531 20.3069 8.84263 19.5926 9.36161Z" />
        </svg>
      </a>
      <a href="https://satvikcoder.hashnode.dev/" className="social_icon">
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="#918E9B"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22.3214 0.5H2.67857C1.96817 0.5 1.28686 0.782206 0.784535 1.28454C0.282206 1.78687 0 2.46817 0 3.17857L0 22.8214C0 23.5318 0.282206 24.2131 0.784535 24.7155C1.28686 25.2178 1.96817 25.5 2.67857 25.5H10.3376V17.0006H6.82199V13H10.3376V9.95089C10.3376 6.4827 12.4023 4.56696 15.5647 4.56696C17.0792 4.56696 18.6629 4.83705 18.6629 4.83705V8.24107H16.918C15.1987 8.24107 14.6624 9.30804 14.6624 10.4023V13H18.5006L17.8867 17.0006H14.6624V25.5H22.3214C23.0318 25.5 23.7131 25.2178 24.2155 24.7155C24.7178 24.2131 25 23.5318 25 22.8214V3.17857C25 2.46817 24.7178 1.78687 24.2155 1.28454C23.7131 0.782206 23.0318 0.5 22.3214 0.5Z" />
        </svg>
      </a>
      <a
        href="https://www.youtube.com/c/BabyandMomMEGHA"
        className="social_icon"
      >
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="#918E9B"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.5 10.0234C11.9113 10.0237 11.336 10.1984 10.8466 10.5256C10.3573 10.8528 9.97593 11.3178 9.75081 11.8617C9.52569 12.4056 9.46691 13.0041 9.58188 13.5814C9.69686 14.1587 9.98044 14.689 10.3968 15.1051C10.8131 15.5213 11.3435 15.8047 11.9208 15.9195C12.4982 16.0342 13.0966 15.9752 13.6405 15.7499C14.1843 15.5246 14.6491 15.143 14.9761 14.6536C15.3031 14.1641 15.4777 13.5887 15.4777 13C15.4771 12.2106 15.1631 11.4536 14.6048 10.8955C14.0465 10.3374 13.2894 10.0237 12.5 10.0234ZM19.4593 7.73549C19.3077 7.35148 19.0789 7.00269 18.787 6.71077C18.4951 6.41886 18.1463 6.19004 17.7623 6.0385C16.5904 5.57589 13.8002 5.67969 12.5 5.67969C11.1998 5.67969 8.41239 5.57199 7.23717 6.0385C6.85315 6.19004 6.50436 6.41886 6.21245 6.71077C5.92053 7.00269 5.69171 7.35148 5.54018 7.73549C5.07812 8.90737 5.18136 11.7003 5.18136 12.9994C5.18136 14.2986 5.07813 17.0882 5.54241 18.264C5.69394 18.648 5.92276 18.9968 6.21468 19.2887C6.5066 19.5806 6.85538 19.8094 7.2394 19.9609C8.41127 20.4235 11.2015 20.3198 12.5022 20.3198C13.803 20.3198 16.5893 20.4275 17.7645 19.9609C18.1485 19.8094 18.4973 19.5806 18.7892 19.2887C19.0811 18.9968 19.31 18.648 19.4615 18.264C19.9275 17.0921 19.8203 14.2991 19.8203 13C19.8203 11.7009 19.9275 8.91183 19.4615 7.73605L19.4593 7.73549ZM12.5 17.5759C11.595 17.5759 10.7103 17.3075 9.95777 16.8047C9.20527 16.3019 8.61877 15.5873 8.27243 14.7511C7.92609 13.915 7.83547 12.9949 8.01203 12.1073C8.18859 11.2197 8.62441 10.4043 9.26436 9.76436C9.90431 9.12441 10.7197 8.68859 11.6073 8.51203C12.4949 8.33547 13.415 8.42609 14.2511 8.77243C15.0873 9.11877 15.8019 9.70527 16.3047 10.4578C16.8075 11.2103 17.0759 12.095 17.0759 13C17.0766 13.6011 16.9588 14.1965 16.7291 14.752C16.4994 15.3075 16.1623 15.8122 15.7373 16.2373C15.3122 16.6623 14.8075 16.9994 14.252 17.2291C13.6965 17.4588 13.1011 17.5766 12.5 17.5759ZM17.2645 9.30022C17.0532 9.30033 16.8467 9.23779 16.671 9.12049C16.4952 9.0032 16.3583 8.83642 16.2773 8.64127C16.1964 8.44611 16.1752 8.23134 16.2163 8.02411C16.2575 7.81689 16.3592 7.62652 16.5085 7.47709C16.6579 7.32766 16.8482 7.22588 17.0554 7.18463C17.2626 7.14337 17.4774 7.16449 17.6726 7.24531C17.8678 7.32614 18.0346 7.46304 18.152 7.63869C18.2694 7.81435 18.332 8.02087 18.332 8.23214C18.3326 8.37244 18.3055 8.51147 18.2522 8.64127C18.199 8.77106 18.1206 8.88906 18.0216 8.9885C17.9227 9.08794 17.805 9.16686 17.6755 9.22074C17.5459 9.27461 17.407 9.30238 17.2667 9.30246L17.2645 9.30022ZM22.3214 0.5H2.67857C1.96817 0.5 1.28686 0.782206 0.784535 1.28454C0.282206 1.78687 0 2.46817 0 3.17857L0 22.8214C0 23.5318 0.282206 24.2131 0.784535 24.7155C1.28686 25.2178 1.96817 25.5 2.67857 25.5H22.3214C23.0318 25.5 23.7131 25.2178 24.2155 24.7155C24.7178 24.2131 25 23.5318 25 22.8214V3.17857C25 2.46817 24.7178 1.78687 24.2155 1.28454C23.7131 0.782206 23.0318 0.5 22.3214 0.5ZM21.3661 16.683C21.2941 18.1133 20.9676 19.3806 19.9235 20.4219C18.8795 21.4632 17.6133 21.7963 16.1847 21.8644C14.7109 21.9475 10.2924 21.9475 8.81864 21.8644C7.38839 21.7924 6.12556 21.4654 5.0798 20.4219C4.03404 19.3783 3.70536 18.1105 3.63728 16.683C3.55413 15.2087 3.55413 10.7896 3.63728 9.31697C3.70926 7.88672 4.03181 6.61942 5.0798 5.57813C6.12779 4.53683 7.39397 4.20759 8.81864 4.13951C10.2924 4.05636 14.7109 4.05636 16.1847 4.13951C17.615 4.2115 18.8817 4.5385 19.9235 5.58203C20.9654 6.62556 21.298 7.89342 21.3661 9.32366C21.4492 10.7924 21.4492 15.2076 21.3661 16.683Z" />
        </svg>
      </a>
      <a href="https://github.com/Megha-prog" className="social_icon">
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="#918E9B"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M22.3214 0.5H2.67857C1.19978 0.5 0 1.69978 0 3.17857V22.8214C0 24.3002 1.19978 25.5 2.67857 25.5H22.3214C23.8002 25.5 25 24.3002 25 22.8214V3.17857C25 1.69978 23.8002 0.5 22.3214 0.5ZM15.4743 21.9118C15.0056 21.9955 14.8326 21.7054 14.8326 21.4654C14.8326 21.1641 14.8438 19.6239 14.8438 18.3795C14.8438 17.5089 14.5536 16.9565 14.2132 16.6663C16.2779 16.4375 18.4542 16.1529 18.4542 12.5871C18.4542 11.5714 18.0915 11.0636 17.5 10.4107C17.5949 10.1708 17.9129 9.18304 17.4051 7.89955C16.6295 7.6596 14.8549 8.89844 14.8549 8.89844C14.1183 8.69197 13.3203 8.58594 12.5335 8.58594C11.7467 8.58594 10.9487 8.69197 10.2121 8.89844C10.2121 8.89844 8.4375 7.6596 7.66183 7.89955C7.15402 9.17746 7.46652 10.1652 7.56697 10.4107C6.97545 11.0636 6.69643 11.5714 6.69643 12.5871C6.69643 16.1362 8.7779 16.4375 10.8426 16.6663C10.5748 16.9063 10.3348 17.3192 10.2511 17.9107C9.72098 18.1507 8.36496 18.5636 7.5558 17.135C7.04799 16.2533 6.13281 16.1808 6.13281 16.1808C5.2288 16.1696 6.07143 16.75 6.07143 16.75C6.67411 17.029 7.09821 18.1004 7.09821 18.1004C7.63951 19.7578 10.2288 19.1998 10.2288 19.1998C10.2288 19.9754 10.24 21.2366 10.24 21.4654C10.24 21.7054 10.0725 21.9955 9.59822 21.9118C5.91518 20.6786 3.33705 17.1741 3.33705 13.0781C3.33705 7.95536 7.25446 4.06585 12.3772 4.06585C17.5 4.06585 21.6518 7.95536 21.6518 13.0781C21.6574 17.1741 19.1574 20.6842 15.4743 21.9118ZM10 18.5022C9.89397 18.5246 9.79353 18.4799 9.78237 18.4074C9.77121 18.3237 9.84375 18.2511 9.94978 18.2288C10.0558 18.2176 10.1562 18.2623 10.1674 18.3348C10.1842 18.4074 10.1116 18.4799 10 18.5022ZM9.46987 18.452C9.46987 18.5246 9.38616 18.5859 9.27455 18.5859C9.15179 18.5971 9.06808 18.5357 9.06808 18.452C9.06808 18.3795 9.15179 18.3181 9.26339 18.3181C9.36942 18.3069 9.46987 18.3683 9.46987 18.452ZM8.70536 18.3906C8.68304 18.4632 8.57143 18.4967 8.47656 18.4632C8.37054 18.4408 8.29799 18.3571 8.32031 18.2846C8.34264 18.2121 8.45424 18.1786 8.54911 18.2009C8.66071 18.2344 8.73326 18.3181 8.70536 18.3906ZM8.01897 18.0893C7.96875 18.1507 7.86272 18.1395 7.77902 18.0558C7.69531 17.9833 7.67299 17.8772 7.7288 17.827C7.77902 17.7656 7.88505 17.7768 7.96875 17.8605C8.0413 17.933 8.0692 18.0446 8.01897 18.0893ZM7.51116 17.5815C7.46094 17.615 7.36607 17.5815 7.30469 17.4978C7.2433 17.4141 7.2433 17.3192 7.30469 17.2801C7.36607 17.2299 7.46094 17.269 7.51116 17.3527C7.57255 17.4364 7.57255 17.5368 7.51116 17.5815ZM7.14844 17.0402C7.09822 17.0904 7.01451 17.0625 6.95313 17.0067C6.89174 16.9342 6.88058 16.8504 6.9308 16.8114C6.98103 16.7612 7.06473 16.7891 7.12612 16.8449C7.1875 16.9174 7.19866 17.0011 7.14844 17.0402ZM6.77455 16.6272C6.75223 16.6775 6.67969 16.6886 6.6183 16.6496C6.54576 16.6161 6.51228 16.5547 6.5346 16.5045C6.55692 16.471 6.6183 16.4542 6.69085 16.4821C6.76339 16.5212 6.79688 16.5826 6.77455 16.6272Z" />
        </svg>
      </a>
    </div>
  );
}

export default App;
